import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, H4, MenuItem, Switch, NumericInput } from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';
import { withTranslation } from 'react-i18next';

import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';


class OccurrencesParams extends React.PureComponent {

  handleSingleSelectChange = (e) => {
    const { name, value } = e.target;
    this.props.onValueChange('occurrencesParamValues', name, value);
  }

  handleChangeItemToList = (paramName, item) => {
    const paramList = this.props.values[paramName];

    let newParamList;
    if (!paramList.includes(item)) {
      newParamList = [...paramList, item];
    } else {
      newParamList = paramList.filter(el => el !== item);
    }

    this.props.onValueChange('occurrencesParamValues', paramName, newParamList);
  }

  handleBoolToTextChange = (e) => {
    const name = e.target.name;

    // console.log(`in handleBoolToTextChange, ${name} new value: ${!this.props.values[name]}`);

    const newBoolValue = !this.props.values[name];
    const newIntValue = newBoolValue ? 1 : 0;
    this.props.onValueChange('occurrencesParamValues', name, newIntValue);
  }

  render() {

 
    const {
      nodeMaskType,
      nodeMaskFeatures,
      collocMaskFeatures,
      kwicNode,
      concordSpan,
      fullConcordSpan,
      dispCriterion,
      assocMeasure,
      innerCollocs,
      minNbCooc,
      maxCooc,
      calcContextTree,
      minWordSketchLLR,
      maxWordSketchLength
    } = this.props.values;
    const {t} = this.props;

    const fromPivotOnly = this.props.values.fromPivotOnly ? true : false;
    const realizeOnlyOne = this.props.values.realizeOnlyOne ? true : false;
    
    const computeEstimatedFreq = this.props.values.computeEstimatedFreq ? true : false;
    const runMultivar = this.props.values.runMultivar ? true : false;

    return (
      <>
        <H4><u>{t('realizationDefinition')}</u></H4>

        <EnhancedSingleSelect
          label={t('realizationType')}
          helperText={t('asSurfaceOrQueryInstanciationOrIncludingSubTree')}
          options={['surface', 'query', 'tree']}
          name='nodeMaskType'
          value={nodeMaskType}
          onChange={this.handleSingleSelectChange}
          popoverProps={{ minimal: true }}
        />

        <FormGroup
          label={t('relevantNodeFeatures')}
          helperText={t('formLemmaCatOthers')}
          inline={true}
        >
          <MultiSelect
            items={["w", "l", "c", "f"]}
            itemRenderer={
              (item, { handleClick, modifiers }) => (
                <MenuItem
                  key={item}
                  active={modifiers.active}
                  text={item}
                  icon={nodeMaskFeatures.includes(item) ? 'tick' : 'blank'}
                  onClick={handleClick}
                  shouldDismissPopover={false}
                />
              )
            }
            itemPredicate={(query, testedElement) => testedElement.includes(query)}
            onItemSelect={item => this.handleChangeItemToList('nodeMaskFeatures', item)}
            selectedItems={nodeMaskFeatures}
            tagInputProps={{
              interactive: true,
              onRemove: item => this.handleChangeItemToList('nodeMaskFeatures', item),
            }}
            tagRenderer={item => item}
            noResults={<MenuItem disabled={true} text={t('noResult')} />}
          />
        </FormGroup>

        <FormGroup
          label={t('relevantCollocFeatures')}
          helperText={t('formLemmaCatOthersRelsPos')}
          inline={true}
        >
          <MultiSelect
            items={["w", "l", "c", "f", "r", "sentP", "paraP", "divP", "txtP"]}
            itemRenderer={
              (item, { handleClick, modifiers }) => (
                <MenuItem
                  key={item}
                  active={modifiers.active}
                  text={item}
                  icon={collocMaskFeatures.includes(item) ? 'tick' : 'blank'}
                  onClick={handleClick}
                  shouldDismissPopover={false}
                />
              )
            }
            itemPredicate={(query, testedElement) => testedElement.includes(query)}
            onItemSelect={item => this.handleChangeItemToList('collocMaskFeatures', item)}
            selectedItems={collocMaskFeatures}
            tagInputProps={{
              interactive: true,
              onRemove: item => this.handleChangeItemToList('collocMaskFeatures', item),
            }}
            tagRenderer={item => item}
            noResults={<MenuItem disabled={true} text={t('noResult')} />}
          />
        </FormGroup>

        <H4><u>{t('cooccurrence')}</u></H4>

        <FormGroup
          label={t('minNbCooc')}
          inline={true}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={minNbCooc}
              onValueChange={(newValue) => this.props.onValueChange('occurrencesParamValues', 'minNbCooc', newValue)}
          />
        </FormGroup>

        <FormGroup
          label={t('maxCooc')}
          inline={true}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={maxCooc}
              onValueChange={(newValue) => this.props.onValueChange('occurrencesParamValues', 'maxCooc', newValue)}
          />
        </FormGroup>

        <Switch
          checked={calcContextTree}
          name="calcContextTree"
          label={t('calcContextTree')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <H4><u>{t('wordsketches')}</u></H4>

        <FormGroup
          label={t('minWordSketchLLR')}
          inline={true}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={minWordSketchLLR}
              onValueChange={(newValue) => this.props.onValueChange('occurrencesParamValues', 'minWordSketchLLR', newValue)}
          />
        </FormGroup>

        <FormGroup
          label={t('maxWordSketchLength')}
            inline={true}
        >         

          <NumericInput
            min={10} buttonPosition={null}
            value={maxWordSketchLength}
              onValueChange={(newValue) => this.props.onValueChange('occurrencesParamValues', 'maxWordSketchLength', newValue)}
          />
        </FormGroup>  

        <H4><u>{t('kwicDisplay')}</u></H4>

        <EnhancedSingleSelect
          label={t("kwicCentralFormat")}
          helperText={t('tok1OrFull')}
          options={["#1", "full"]}
          name='kwicNode'
          value={kwicNode}
          onChange={this.handleSingleSelectChange}
          popoverProps={{ minimal: true }}
        />

        <Switch
          checked={fullConcordSpan}
          name="fullConcordSpan"
          label={t('fullConcordSpan')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <FormGroup
          label={t('concordSpan')}
          inline={true}
        >
          <NumericInput
            min={20} buttonPosition={null}
            value={concordSpan}
              onValueChange={(newValue) => this.props.onValueChange('occurrencesParamValues', 'concordSpan', newValue)}
          />
        </FormGroup>

        <H4><u>{t('computationParam')}</u></H4>

        <Switch
          checked={realizeOnlyOne}
          name="realizeOnlyOne"
          label={t('takeOnlyNodeInRealization')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <Switch
          checked={fromPivotOnly}
          name="fromPivotOnly"
          label={t('coocWithNodeOnly')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <Switch
          checked={computeEstimatedFreq}
          name="computeEstimatedFreq"
          label={t('calcEstimatedValues')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <EnhancedSingleSelect
          label={t('dispCriterion')}
          options={["file", "doc", "author", "year", "title", "sub_genre", "decade", "any"]}
          name='dispCriterion'
          value={dispCriterion}
          onChange={this.handleSingleSelectChange}
          popoverProps={{ minimal: true }}
        />

        <EnhancedSingleSelect
          label={t('assocMeasure')}
          options={['am.log.likelihood','am.pmi','am.z.score','am.t.score','am.frequency','am.p.cond']}
          name='assocMeasure'
          value={assocMeasure}
          onChange={this.handleSingleSelectChange}
          popoverProps={{ minimal: true }}
        />
        <EnhancedSingleSelect
          label={t('innerCollocs')}
          options={['','am.log.likelihood','am.pmi','am.z.score','am.t.score','am.frequency','am.p.cond']}
          name='innerCollocs'
          value={innerCollocs}
          onChange={this.handleSingleSelectChange}
          popoverProps={{ minimal: true }}
        />

        <Switch
          checked={runMultivar}
          name="runMultivar"
          label={t('runMultivar')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />
      </>
    );
  }
}

OccurrencesParams.propTypes = {
  values: PropTypes.shape({
    nodeMaskType: PropTypes.string,
    nodeMaskFeatures: PropTypes.arrayOf(PropTypes.string),
    collocMaskFeatures: PropTypes.arrayOf(PropTypes.string),
    kwicNode: PropTypes.string,
    concordSpan: PropTypes.number,
    fromPivotOnly: PropTypes.number,
    minNbCooc: PropTypes.number,
    maxCooc: PropTypes.number,
    computeEstimatedFreq: PropTypes.number,
    dispCriterion: PropTypes.string,
    innerCollocs: PropTypes.string,
    calcContextTree: PropTypes.number,
    assocMeasure: PropTypes.string,
    runMultivar: PropTypes.number,
    minWordSketchLLR: PropTypes.number,
    maxWordSketchLength: PropTypes.number,
  }),
  onValueChange: PropTypes.func,
};

export default withTranslation()(OccurrencesParams);